// src/features/cliente/components/ClienteRedirect.tsx
// @ts-nocheck
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { supabase } from "@/features/sistema/services/supabaseClient";

export function ClienteRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const didNavRef = useRef(false);

  useEffect(() => {
    if (didNavRef.current) return; // evita loops
    (async () => {
      const { data: auth } = await supabase.auth.getUser();
      const uid = auth.user?.id;
      if (!uid) return navigate("/", { replace: true });

      const { data: vinc } = await supabase
        .from("obras_clientes")
        .select("obra_id")
        .eq("user_id", uid)
        .eq("ativo", true)
        .maybeSingle();

      if (!vinc?.obra_id) return navigate("/sem-acesso", { replace: true });

      const dest = `/cliente/obras/${vinc.obra_id}`;
      if (location.pathname !== dest) {
        didNavRef.current = true;
        navigate(dest, { replace: true });
      }
    })();
  }, [navigate, location.pathname]);

  return null;
}
